
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2839',
  depVersions: {
  "customer-portal-app": "static-1.2839",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.488",
  "data-fetching-client": "static-1.9825",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.25896",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5761",
  "hs-test-utils": "static-1.8188",
  "hub-http": "static-1.6387",
  "hub-http-shared-msw-handlers": "static-1.10384",
  "hubspot-dlb": "static-2.1854",
  "hubspot-prosemirror": "static-1.18731",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11644",
  "I18n": "static-7.1644",
  "immutable": "static-2.79",
  "jasmine-runner": "static-1.6624",
  "payment-link-components": "static-1.23899",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7250",
  "quartz-core": "static-1.6469",
  "quartz-i18n": "static-1.925",
  "react": "static-7.189",
  "react-colorpicker": "static-2.10374",
  "react-dlb": "static-1.83",
  "react-utils": "static-2.5461",
  "reselect": "static-3.7",
  "rich-text-lib": "static-1.20126",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.18214",
  "ui-components-test-utils": "static-1.5781",
  "UIComponents": "static-3.8590",
  "foundations-assets": "static-1.5041",
  "foundations-components": "static-1.8262",
  "foundations-theming": "static-1.4606",
  "foundations-theming-specialty": "static-1.2322",
  "framer-motion": "static-1.74",
  "metrics-js": "static-1.9637",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1231",
  "quartz-config": "static-1.1028",
  "quartz-routing": "static-1.680",
  "quick-fetch": "static-1.4037",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16867",
  "rpc-client-utils": "static-1.4825",
  "sanitize-text": "static-1.8313",
  "styled-components": "static-2.89",
  "tanstack-table": "static-1.57",
  "ui-addon-draggable": "static-3.4925",
  "ui-addon-react-router-dom": "static-1.9701",
  "usage-tracker": "static-1.7519",
  "usage-tracker-anonymous": "static-1.5936",
  "usage-tracker-core": "static-1.7369",
  "video-components-external": "static-1.11845",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3521",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3527",
  "quartz-webpack": "static-1.3474",
  "bend-plugin-quartz-routing": "static-1.328",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.84",
  "customer-data-objects": "static-1.7846",
  "frontend-preferences-client": "static-1.8095",
  "laboratory-lib": "static-3.7319",
  "onboarding-scopes": "static-1.6626",
  "seat-types-lib": "static-1.396",
  "ui-addon-opt": "static-4.8528",
  "HeadJS": "static-2.776",
  "hs-test-utils-bend-plugin": "static-1.3299",
  "msw": "static-1.39",
  "testing-library": "static-1.154",
  "hs-locale-management": "static-1.202",
  "ts-schema": "static-1.4201",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.8014",
  "content-media-capture": "static-1.5068",
  "cssUtils": "static-1.841",
  "customer-data-ui-utilities": "static-1.9991",
  "file-manager-components": "static-1.24125",
  "HubStyle": "static-2.11951",
  "knowledge-content-types": "static-1.8584",
  "PatternValidationJS": "static-1.437",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.490",
  "ui-addon-emoji-picker": "static-1.10051",
  "ui-addon-i18n": "static-1.11316",
  "ui-business-units-lib": "static-1.9246",
  "ui-shepherd-react": "static-3.10429",
  "video-data-lib": "static-1.35503",
  "i18n-data": "static-1.225",
  "moment-timezone": "static-5.85",
  "jasmine": "static-4.4491",
  "commerce-tours-lib": "static-1.6422",
  "customer-data-properties": "static-1.52152",
  "getting-started-shared-tasks": "static-1.18920",
  "growth-onboarding-reliability": "static-1.5250",
  "onboarding-tours": "static-1.16923",
  "reference-resolvers-lite": "static-1.8264",
  "sales-checkout-service-client": "static-1.3742",
  "ui-addon-iframeable": "static-1.9244",
  "user-context": "static-1.5277",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.851",
  "hubspotter-http": "static-1.4771",
  "icons": "static-2.664",
  "mobile-manifest-mixins": "static-1.551",
  "module-federation": "static-1.28",
  "quartz-auth": "static-1.925",
  "quartz-head": "static-1.915",
  "quartz-test": "static-1.925",
  "quartz-tracking": "static-1.629",
  "trellis-components": "static-1.2291",
  "ui-fonts": "static-1.906",
  "usage-tracker-container": "static-1.7509",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9592",
  "data-token-picker": "static-1.16709",
  "FileManagerLib": "static-1.39765",
  "property-translator": "static-1.5561",
  "atom": "static-1.5242",
  "merchandise-lib": "static-1.266",
  "purchase-motions-components": "static-1.6161",
  "salesImages": "static-1.528",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5745",
  "react-create-root-preference": "static-1.44",
  "react-select-plus": "static-1.107",
  "react-virtualized": "static-2.101",
  "ui-images": "static-2.1204",
  "bend-plugin-foundations-components": "static-1.4531",
  "floating-ui": "static-1.59",
  "react-aria": "static-1.68",
  "trellis-assets": "static-1.2272",
  "bend-plugin-foundations-theming": "static-1.3089",
  "foundations-theming-base": "static-1.3591",
  "stylex": "static-1.36",
  "interframe": "static-3.4923",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5933",
  "web-vitals": "static-1.8",
  "bend-plugin-chirp-manifest": "static-1.235",
  "chirp-fetch": "static-1.2055",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4644",
  "react-flip-move": "static-1.73",
  "apollo-link-hub-http": "static-2.4818",
  "content-media-composition-data-lib": "static-1.12872",
  "content-media-compositions": "static-2.16879",
  "idb-keyval": "static-1.46",
  "immer": "static-1.33",
  "immerable": "static-1.4317",
  "magpie-lib": "static-1.5663",
  "magpie-types": "static-1.5123",
  "media-bridge-lib": "static-1.19224",
  "bender-build-tools": "static-1.3301",
  "inbound-db-properties-service-client": "static-1.3967",
  "superstore": "static-1.4926",
  "feedback-loader": "static-1.29615",
  "ai-components-ui-library": "static-1.9386",
  "ui-addon-video-player": "static-1.8872",
  "ui-coaching-tips": "static-1.29041",
  "ContentUtils": "static-1.68872",
  "fix-webm-duration": "static-1.25",
  "notification-sounds": "static-1.4592",
  "sassPrefix": "static-1.159",
  "react-dnd-compat": "static-1.4782",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "breeze-engine-lib": "static-1.1327",
  "copilot-toolkit": "static-1.11572",
  "avatar-components": "static-1.2666",
  "navigation-messaging": "static-1.7802",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8343",
  "commerce-products-lib": "static-1.10199",
  "crm-message-bus": "static-1.43471",
  "growth-data-modal": "static-1.5706",
  "hubspot-apollo-client": "static-1.5046",
  "onboarding-tours-client": "static-1.5137",
  "calling-global-api": "static-1.65103",
  "calling-internal-common": "static-1.31480",
  "calling-lifecycle-internal": "static-1.66485",
  "calling-lifecycle-messages": "static-1.58779",
  "conditional-properties-service-client": "static-1.3918",
  "crm-links": "static-1.6482",
  "crm-pipelines-api-client-types": "static-1.4258",
  "customer-data-objects-ui-components": "static-1.13197",
  "customer-data-properties-shared-msw-handlers": "static-1.9711",
  "customer-data-property-utils": "static-1.8262",
  "external-options-client-types": "static-1.4247",
  "formula-editor": "static-1.14557",
  "framework-data-schema-resolvers": "static-1.7061",
  "google-libphonenumber": "static-1.40",
  "hs-resources": "static-1.346",
  "inbound-db-meta-service-client": "static-1.3708",
  "inbounddb-objects-service-types": "static-1.4338",
  "meetings-icalendar-utils-lib": "static-1.800",
  "multi-currency-client-types": "static-1.3812",
  "object-builder-ui-client": "static-1.49305",
  "pipeline-validation-client-types": "static-1.4087",
  "property-value-citations": "static-1.2766",
  "pulse": "static-1.778",
  "smart-property-lib": "static-1.8047",
  "tiered-pricing": "static-1.1692",
  "topics-actions-lib": "static-1.306",
  "ui-addon-form-validation": "static-1.11157",
  "zustand": "static-1.74",
  "growth-onboarding-confetti": "static-1.3232",
  "growth-onboarding-next-action-utils": "static-1.2423",
  "navigation-components": "static-1.18475",
  "onboarding-tours-utils": "static-1.989",
  "ui-shepherd-tracker": "static-1.7810",
  "ui-universal-auth": "static-1.9176",
  "batch-promise": "static-1.1711",
  "getting-started-shared-tasks-store": "static-1.18038",
  "hubspotter-http-shared-msw-handlers": "static-1.10382",
  "usage-tracker-session-replay": "static-1.5205",
  "base-ui": "static-1.16",
  "react-day-picker": "static-1.5",
  "trellis-theming": "static-1.1116",
  "tanstack-virtual": "static-1.32",
  "audio-components": "static-1.6171",
  "FileManagerCore": "static-1.39624",
  "FileManagerImages": "static-1.37276",
  "video-components": "static-1.13847",
  "foundations-components-legacy": "static-1.1287",
  "purchase-motions-api": "static-1.6164",
  "signup-constants": "static-1.19289",
  "signup-ui-url-generator": "static-2.8225",
  "usage-tracker-public": "static-1.7330",
  "reactive-lib": "static-1.891",
  "simple-logging-lib": "static-1.3217",
  "chatspot-core": "static-1.22161",
  "growth-onboarding-feedback-components": "static-1.6746",
  "cms-field-types": "static-1.4982",
  "content-icons-ui": "static-1.2277",
  "integrations-lib": "static-1.16704",
  "underscore": "static-1.8",
  "breeze-engine-core": "static-1.605",
  "ably": "static-2.2",
  "highlight.js": "static-1.81",
  "markdown-it": "static-1.6",
  "commerce-permissions": "static-1.942",
  "customer-data-tracking": "static-1.7051",
  "products-iframe-lib": "static-1.8346",
  "products-ui-components-shared-msw-handlers": "static-1.10766",
  "restore-request-side-panel-lib": "static-1.1349",
  "onboarding-data-sync-lib": "static-1.2254",
  "hubspot-apollo-cache": "static-1.505",
  "calling-error-reporting": "static-1.31487",
  "shared-worker-versioning": "static-1.11203",
  "calling-usage-tracker": "static-1.6708",
  "voice-sms-access-library": "static-1.1616",
  "conversations-skeleton-state": "static-1.7415",
  "location-customization-utils-lib": "static-1.9762",
  "bark-lib": "static-1.16642",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.97",
  "crm-properties-common-lib": "static-1.6055",
  "react-codemirror": "static-1.10799",
  "fdsr-migration-layer": "static-1.180",
  "framework-builder-read-service-client": "static-1.4126",
  "framework-data-schema-quick-fetch": "static-1.6966",
  "persist-promise": "static-1.3868",
  "event-emitter": "static-1.1117",
  "bend-plugin-pulse": "static-1.281",
  "fast-json-patch": "static-1.65",
  "data-agent-kit": "static-1.463",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10467",
  "fsm": "static-1.3897",
  "policy-lib": "static-1.6952",
  "react-tinymce": "static-1.55704",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10530",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54830",
  "tinymce-plugins": "static-1.57944",
  "tinymce-themes": "static-1.56800",
  "growth-onboarding-next-action-components": "static-1.2451",
  "user-context-client": "static-1.4718",
  "nest": "static-1.401",
  "unified-auth-core-lib": "static-1.972",
  "amplitude-session-replay-browser": "static-1.60",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.56",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4699",
  "video-embed": "static-1.36337",
  "social-insights-client-types": "static-1.22528",
  "flux-actions": "static-1.351",
  "integrations-error-boundary-lib": "static-1.14119",
  "integrations-tracking-lib": "static-1.5773",
  "native-integrations-shared-strings": "static-1.7947",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10531",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.690",
  "sales-views-client-types": "static-1.4425",
  "InboxConnectUtils": "static-4.15277",
  "meetings-connect-utils-lib": "static-1.7774",
  "calling-orchestration-schema": "static-1.36393",
  "crm-record-cards-service-types": "static-1.3705",
  "react-reducer-toolkit": "static-1.16075",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "highcharts": "static-8.106",
  "trellis-story-utils": "static-1.4674",
  "storybook-react": "static-1.35",
  "hub-http-contrib": "static-1.3210",
  "tinymce-data": "static-1.40915",
  "ui-addon-sales-email": "static-1.5379",
  "layout-dnd-components": "static-1.12773",
  "layout-dnd-utils": "static-1.11748",
  "ui-brand-identity-lib": "static-1.15903",
  "NamespacedHubStyle": "static-2.9174",
  "outpost": "static-1.4335",
  "universal-page-editor-lib": "static-1.3180",
  "adobe-sign-auth-lib": "static-1.185",
  "ads-unified-auth-lib": "static-1.668",
  "google-sheets-integration-lib": "static-1.749",
  "microsoft-drive-integration-lib": "static-1.878",
  "surveymonkey-integration-lib": "static-1.201",
  "slack-ui-library": "static-1.10564",
  "ContentData": "static-1.68947",
  "layout-data-lib": "static-1.10073",
  "advanced-menus-core": "static-1.15410",
  "advanced-menus-lib": "static-1.12307",
  "ExportDialog": "static-6.10546",
  "ui-memberships-settings-lib": "static-1.34515",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15409",
  "simple-menus-lib": "static-1.16926"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2839",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.488",
  "data-fetching-client": "/data-fetching-client/static-1.9825",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.25896",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5761",
  "hs-test-utils": "/hs-test-utils/static-1.8188",
  "hub-http": "/hub-http/static-1.6387",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10384",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18731",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11644",
  "I18n": "/I18n/static-7.1644",
  "immutable": "/immutable/static-2.79",
  "jasmine-runner": "/jasmine-runner/static-1.6624",
  "payment-link-components": "/payment-link-components/static-1.23899",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7250",
  "quartz-core": "/quartz-core/static-1.6469",
  "quartz-i18n": "/quartz-i18n/static-1.925",
  "react": "/react/static-7.189",
  "react-colorpicker": "/react-colorpicker/static-2.10374",
  "react-dlb": "/react-dlb/static-1.83",
  "react-utils": "/react-utils/static-2.5461",
  "reselect": "/reselect/static-3.7",
  "rich-text-lib": "/rich-text-lib/static-1.20126",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18214",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5781",
  "UIComponents": "/UIComponents/static-3.8590",
  "foundations-assets": "/foundations-assets/static-1.5041",
  "foundations-components": "/foundations-components/static-1.8262",
  "foundations-theming": "/foundations-theming/static-1.4606",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2322",
  "framer-motion": "/framer-motion/static-1.74",
  "metrics-js": "/metrics-js/static-1.9637",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1231",
  "quartz-config": "/quartz-config/static-1.1028",
  "quartz-routing": "/quartz-routing/static-1.680",
  "quick-fetch": "/quick-fetch/static-1.4037",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16867",
  "rpc-client-utils": "/rpc-client-utils/static-1.4825",
  "sanitize-text": "/sanitize-text/static-1.8313",
  "styled-components": "/styled-components/static-2.89",
  "tanstack-table": "/tanstack-table/static-1.57",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4925",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9701",
  "usage-tracker": "/usage-tracker/static-1.7519",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5936",
  "usage-tracker-core": "/usage-tracker-core/static-1.7369",
  "video-components-external": "/video-components-external/static-1.11845",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3521",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3527",
  "quartz-webpack": "/quartz-webpack/static-1.3474",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.328",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.84",
  "customer-data-objects": "/customer-data-objects/static-1.7846",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8095",
  "laboratory-lib": "/laboratory-lib/static-3.7319",
  "onboarding-scopes": "/onboarding-scopes/static-1.6626",
  "seat-types-lib": "/seat-types-lib/static-1.396",
  "ui-addon-opt": "/ui-addon-opt/static-4.8528",
  "HeadJS": "/HeadJS/static-2.776",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3299",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.154",
  "hs-locale-management": "/hs-locale-management/static-1.202",
  "ts-schema": "/ts-schema/static-1.4201",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.8014",
  "content-media-capture": "/content-media-capture/static-1.5068",
  "cssUtils": "/cssUtils/static-1.841",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9991",
  "file-manager-components": "/file-manager-components/static-1.24125",
  "HubStyle": "/HubStyle/static-2.11951",
  "knowledge-content-types": "/knowledge-content-types/static-1.8584",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.490",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10051",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11316",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9246",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10429",
  "video-data-lib": "/video-data-lib/static-1.35503",
  "i18n-data": "/i18n-data/static-1.225",
  "moment-timezone": "/moment-timezone/static-5.85",
  "jasmine": "/jasmine/static-4.4491",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6422",
  "customer-data-properties": "/customer-data-properties/static-1.52152",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18920",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5250",
  "onboarding-tours": "/onboarding-tours/static-1.16923",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8264",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3742",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9244",
  "user-context": "/user-context/static-1.5277",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.851",
  "hubspotter-http": "/hubspotter-http/static-1.4771",
  "icons": "/icons/static-2.664",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.551",
  "module-federation": "/module-federation/static-1.28",
  "quartz-auth": "/quartz-auth/static-1.925",
  "quartz-head": "/quartz-head/static-1.915",
  "quartz-test": "/quartz-test/static-1.925",
  "quartz-tracking": "/quartz-tracking/static-1.629",
  "trellis-components": "/trellis-components/static-1.2291",
  "ui-fonts": "/ui-fonts/static-1.906",
  "usage-tracker-container": "/usage-tracker-container/static-1.7509",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9592",
  "data-token-picker": "/data-token-picker/static-1.16709",
  "FileManagerLib": "/FileManagerLib/static-1.39765",
  "property-translator": "/property-translator/static-1.5561",
  "atom": "/atom/static-1.5242",
  "merchandise-lib": "/merchandise-lib/static-1.266",
  "purchase-motions-components": "/purchase-motions-components/static-1.6161",
  "salesImages": "/salesImages/static-1.528",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5745",
  "react-create-root-preference": "/react-create-root-preference/static-1.44",
  "react-select-plus": "/react-select-plus/static-1.107",
  "react-virtualized": "/react-virtualized/static-2.101",
  "ui-images": "/ui-images/static-2.1204",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4531",
  "floating-ui": "/floating-ui/static-1.59",
  "react-aria": "/react-aria/static-1.68",
  "trellis-assets": "/trellis-assets/static-1.2272",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3089",
  "foundations-theming-base": "/foundations-theming-base/static-1.3591",
  "stylex": "/stylex/static-1.36",
  "interframe": "/interframe/static-3.4923",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5933",
  "web-vitals": "/web-vitals/static-1.8",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.235",
  "chirp-fetch": "/chirp-fetch/static-1.2055",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4644",
  "react-flip-move": "/react-flip-move/static-1.73",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4818",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12872",
  "content-media-compositions": "/content-media-compositions/static-2.16879",
  "idb-keyval": "/idb-keyval/static-1.46",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4317",
  "magpie-lib": "/magpie-lib/static-1.5663",
  "magpie-types": "/magpie-types/static-1.5123",
  "media-bridge-lib": "/media-bridge-lib/static-1.19224",
  "bender-build-tools": "/bender-build-tools/static-1.3301",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3967",
  "superstore": "/superstore/static-1.4926",
  "feedback-loader": "/feedback-loader/static-1.29615",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9386",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8872",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29041",
  "ContentUtils": "/ContentUtils/static-1.68872",
  "fix-webm-duration": "/fix-webm-duration/static-1.25",
  "notification-sounds": "/notification-sounds/static-1.4592",
  "sassPrefix": "/sassPrefix/static-1.159",
  "react-dnd-compat": "/react-dnd-compat/static-1.4782",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1327",
  "copilot-toolkit": "/copilot-toolkit/static-1.11572",
  "avatar-components": "/avatar-components/static-1.2666",
  "navigation-messaging": "/navigation-messaging/static-1.7802",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8343",
  "commerce-products-lib": "/commerce-products-lib/static-1.10199",
  "crm-message-bus": "/crm-message-bus/static-1.43471",
  "growth-data-modal": "/growth-data-modal/static-1.5706",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5046",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5137",
  "calling-global-api": "/calling-global-api/static-1.65103",
  "calling-internal-common": "/calling-internal-common/static-1.31480",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66485",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58779",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3918",
  "crm-links": "/crm-links/static-1.6482",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4258",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13197",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9711",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8262",
  "external-options-client-types": "/external-options-client-types/static-1.4247",
  "formula-editor": "/formula-editor/static-1.14557",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7061",
  "google-libphonenumber": "/google-libphonenumber/static-1.40",
  "hs-resources": "/hs-resources/static-1.346",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3708",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4338",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.800",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3812",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49305",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4087",
  "property-value-citations": "/property-value-citations/static-1.2766",
  "pulse": "/pulse/static-1.778",
  "smart-property-lib": "/smart-property-lib/static-1.8047",
  "tiered-pricing": "/tiered-pricing/static-1.1692",
  "topics-actions-lib": "/topics-actions-lib/static-1.306",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11157",
  "zustand": "/zustand/static-1.74",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3232",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2423",
  "navigation-components": "/navigation-components/static-1.18475",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.989",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7810",
  "ui-universal-auth": "/ui-universal-auth/static-1.9176",
  "batch-promise": "/batch-promise/static-1.1711",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18038",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10382",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5205",
  "base-ui": "/base-ui/static-1.16",
  "react-day-picker": "/react-day-picker/static-1.5",
  "trellis-theming": "/trellis-theming/static-1.1116",
  "tanstack-virtual": "/tanstack-virtual/static-1.32",
  "audio-components": "/audio-components/static-1.6171",
  "FileManagerCore": "/FileManagerCore/static-1.39624",
  "FileManagerImages": "/FileManagerImages/static-1.37276",
  "video-components": "/video-components/static-1.13847",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1287",
  "purchase-motions-api": "/purchase-motions-api/static-1.6164",
  "signup-constants": "/signup-constants/static-1.19289",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8225",
  "usage-tracker-public": "/usage-tracker-public/static-1.7330",
  "reactive-lib": "/reactive-lib/static-1.891",
  "simple-logging-lib": "/simple-logging-lib/static-1.3217",
  "chatspot-core": "/chatspot-core/static-1.22161",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6746",
  "cms-field-types": "/cms-field-types/static-1.4982",
  "content-icons-ui": "/content-icons-ui/static-1.2277",
  "integrations-lib": "/integrations-lib/static-1.16704",
  "underscore": "/underscore/static-1.8",
  "breeze-engine-core": "/breeze-engine-core/static-1.605",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.81",
  "markdown-it": "/markdown-it/static-1.6",
  "commerce-permissions": "/commerce-permissions/static-1.942",
  "customer-data-tracking": "/customer-data-tracking/static-1.7051",
  "products-iframe-lib": "/products-iframe-lib/static-1.8346",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10766",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1349",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2254",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.505",
  "calling-error-reporting": "/calling-error-reporting/static-1.31487",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11203",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6708",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1616",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7415",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9762",
  "bark-lib": "/bark-lib/static-1.16642",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.97",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6055",
  "react-codemirror": "/react-codemirror/static-1.10799",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.180",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4126",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6966",
  "persist-promise": "/persist-promise/static-1.3868",
  "event-emitter": "/event-emitter/static-1.1117",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.281",
  "fast-json-patch": "/fast-json-patch/static-1.65",
  "data-agent-kit": "/data-agent-kit/static-1.463",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10467",
  "fsm": "/fsm/static-1.3897",
  "policy-lib": "/policy-lib/static-1.6952",
  "react-tinymce": "/react-tinymce/static-1.55704",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10530",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54830",
  "tinymce-plugins": "/tinymce-plugins/static-1.57944",
  "tinymce-themes": "/tinymce-themes/static-1.56800",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2451",
  "user-context-client": "/user-context-client/static-1.4718",
  "nest": "/nest/static-1.401",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.972",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.56",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4699",
  "video-embed": "/video-embed/static-1.36337",
  "social-insights-client-types": "/social-insights-client-types/static-1.22528",
  "flux-actions": "/flux-actions/static-1.351",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14119",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5773",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7947",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10531",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.690",
  "sales-views-client-types": "/sales-views-client-types/static-1.4425",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15277",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7774",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36393",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3705",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16075",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "highcharts": "/highcharts/static-8.106",
  "trellis-story-utils": "/trellis-story-utils/static-1.4674",
  "storybook-react": "/storybook-react/static-1.35",
  "hub-http-contrib": "/hub-http-contrib/static-1.3210",
  "tinymce-data": "/tinymce-data/static-1.40915",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5379",
  "layout-dnd-components": "/layout-dnd-components/static-1.12773",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11748",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15903",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9174",
  "outpost": "/outpost/static-1.4335",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3180",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.185",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.668",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.749",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.878",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.201",
  "slack-ui-library": "/slack-ui-library/static-1.10564",
  "ContentData": "/ContentData/static-1.68947",
  "layout-data-lib": "/layout-data-lib/static-1.10073",
  "advanced-menus-core": "/advanced-menus-core/static-1.15410",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12307",
  "ExportDialog": "/ExportDialog/static-6.10546",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34515",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15409",
  "simple-menus-lib": "/simple-menus-lib/static-1.16926"
}
};
